import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from './config.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private URL = 'http://localhost:3000'

  readonly URL_API = this.config.getConfig().url
  constructor(private http: HttpClient, private config:ConfigService, private router: Router) { }

  public login(user: any) {
    return this.http.post(`${this.URL_API}/login`, user);
  }

  loggedInd() {
   return !!localStorage.getItem('user');
  }

 
  logout() {
    localStorage.removeItem('user');
    this.router.navigate(['/login']);
  }

}

